export const themes = {
  default: {
    colors: {
      menu: {
        subMenuActiveText: '#fff',
        menuText: 'rgba(255,255,255,0.7)',
        menubBg: 'linear-gradient(90deg, #47CDF3 0%, #0770ED 39%, #0770ED 100%)',
      },
      themeTextColor: '#000000',
      btnHover: '#00C6FC',
      themeColor2: '#47CDF3',
    },
  },
  dark: {
    colors: {
      menu: {
        subMenuActiveText: '#fff',
        menuText: '#0770ED',
        menubBg: 'linear-gradient(90deg, rgb(24, 23, 23) 0%, #1a1a1a 39%, #1a1a1a 100%)',
      },
      themeTextColor: '#0770ED',
      btnHover: '#00C6FC',
      themeColor2: '#47CDF3',
    },
  },
}

export type ThemeType = keyof typeof themes
